/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freedesc1Inputs */

const zh_plan_freedesc1 = /** @type {(inputs: Plan_Freedesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合体验和入门`)
};

const en_plan_freedesc1 = /** @type {(inputs: Plan_Freedesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with basic AI learning`)
};

const es_plan_freedesc1 = /** @type {(inputs: Plan_Freedesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para empezar`)
};

/**
* | output |
* | --- |
* | "Get started with basic AI learning" |
*
* @param {Plan_Freedesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freedesc1 = /** @type {((inputs?: Plan_Freedesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freedesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freedesc1(inputs)
	if (locale === "en") return en_plan_freedesc1(inputs)
	return es_plan_freedesc1(inputs)
});
export { plan_freedesc1 as "plan_freeDesc" }